var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_12)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70557 0H7.29315C7.7453 0.000966007 8.17866 0.172674 8.4985 0.477588C8.81835 0.782503 8.99865 1.19582 9 1.6272V13.3728C8.99865 13.8042 8.81835 14.2175 8.4985 14.5224C8.17866 14.8273 7.7453 14.999 7.29315 15H1.70557C1.25321 14.9994 0.819594 14.8275 0.499847 14.5223C0.1801 14.217 0.000338339 13.8032 0 13.3716L0 1.6272C0.000676855 1.19584 0.180588 0.782327 0.500298 0.477308C0.820009 0.172289 1.25343 0.000645751 1.70557 0ZM4.49872 13.2288C4.63695 13.2285 4.77214 13.2674 4.88719 13.3405C5.00225 13.4136 5.09199 13.5176 5.14506 13.6394C5.19813 13.7611 5.21215 13.8952 5.18534 14.0245C5.15853 14.1539 5.09209 14.2728 4.99444 14.3661C4.89679 14.4595 4.77231 14.5231 4.63676 14.5489C4.50121 14.5747 4.36068 14.5616 4.23295 14.5111C4.10522 14.4607 3.99604 14.3753 3.91922 14.2657C3.8424 14.156 3.80139 14.0271 3.80139 13.8953C3.80173 13.7188 3.87527 13.5496 4.00593 13.4248C4.1366 13.2999 4.31376 13.2294 4.49872 13.2288ZM8.50867 12.7173V2.04468H0.490048V12.7173H8.50867Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhoneIcon);
export default __webpack_public_path__ + "static/media/mobile-phone-icon.291c966bf797b2d0aea900200d86a62d.svg";
export { ForwardRef as ReactComponent };